import { get, post } from './request'
// 获取滚动站点通知信息
function getSiteNotice(params) {
  return get('/channel_admin/notice/site', params)
}
// 获取站点通知信息详情
function getSiteNoticeDetails(params) {
  return get('/channel_admin/notice/details', params)
}
// 渠道查询是否有未读消息
function getSiteNoticeIsRead(params) {
  return get('/channel_admin/message', params)
}
// 渠道消息更新已读
function getSiteNoticeRead(params) {
  return post('/channel_admin/message', params)
}
// 渠道消息一键更新已读
function getSiteNoticeAllRead(params) {
  return post('/channel_admin/message/bulk', params)
}

export { getSiteNotice, getSiteNoticeDetails, getSiteNoticeIsRead, getSiteNoticeRead, getSiteNoticeAllRead }
